export type ActiveSubmissionStopOutcome =
  "cancelled" | "cancel_requested" | "not_active" | "local" | null;

/** True only when the server confirmed a Stop request or a pending Stop settled. */
export function isConfirmedUserStop({
  outcome,
  observedPendingStop,
  error,
}: {
  outcome: ActiveSubmissionStopOutcome;
  observedPendingStop: boolean;
  error: string | null;
}): boolean {
  if (error) return false;
  return (
    outcome === "cancelled" ||
    outcome === "cancel_requested" ||
    (observedPendingStop && outcome === null)
  );
}
